var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 52V28H52V52H28Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6919 45.9647C44.1533 46.714 44.6546 47.432 45.7166 47.432C46.6086 47.432 47.0766 46.9887 47.0766 46.3753C47.0766 45.6413 46.5926 45.3807 45.6113 44.9533L45.0733 44.724C43.5206 44.0653 42.4879 43.24 42.4879 41.4967C42.4879 39.89 43.7179 38.6673 45.6399 38.6673C47.0086 38.6673 47.9919 39.1413 48.7013 40.3827L47.0253 41.454C46.6566 40.7953 46.2579 40.536 45.6399 40.536C45.0093 40.536 44.6099 40.934 44.6099 41.454C44.6099 42.0967 45.0099 42.3567 45.9333 42.7547L46.4713 42.984C48.3013 43.7633 49.3333 44.5593 49.3333 46.3487C49.3333 48.2767 47.8106 49.3333 45.7666 49.3333C43.7673 49.3333 42.6319 48.33 41.9999 47.088L43.6919 45.9647ZM35.9679 46.0193C36.3053 46.6233 36.8179 47.088 37.5553 47.088C38.2606 47.088 38.6666 46.8093 38.6666 45.726V38.6667H40.8886V46.0673C40.8886 48.312 39.5866 49.3333 37.6853 49.3333C35.9673 49.3333 34.7273 48.1693 34.2219 47.088L35.9679 46.0193Z",
    fill: "#000001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.8e863ab984741c697ca738e6b6ca8d4c.svg";
export { ForwardRef as ReactComponent };